module.exports = __webpack_public_path__ + "img/cog.194e8c76.svg";